<arm-dialog [title]="'Advanced Search'" (onCancel)="onCancel()" (onSubmit)="onSubmit()">
    <div class="search-container">
        <div class="search-column">

          <mat-form-field class="fullWidth" >
            <mat-label>Connection Name</mat-label>
            <input matInput [(ngModel)]="search.connectionName"  name="connection-name" maxlength="255">
          </mat-form-field>

          <mat-form-field class="fullWidth" >
            <mat-label>Connection Edge Name</mat-label>
            <input matInput [(ngModel)]="search.ceName"  name="connection-edge-name" maxlength="255">
          </mat-form-field>

          <ac-input-container label="Operative State">
            <ac-select
              [(acModel)]="search.operativeState"
              [items]="search.operatorStateOptions"
              [allowClear]="true"
              [multiple]="false"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>

          <ac-input-container label="Quality">
            <ac-select
              [(acModel)]="search.quality"
              [items]="search.qualityOptions"
              [allowClear]="true"
              [multiple]="false"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>

        </div>
    </div>
</arm-dialog>
